import React from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import Pagination from '../../../components/base/Pagination/Pagination';
import {
  EquipmentFormatter,
  visualFormatter,
  logFormatter,
  HostNameAndStatusFormatter,
  vehicleRegistrationPlateFormatter,
} from '../../../utils/formatters';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import { Button, Icons } from '../../../components/base/BootstrapComponents';
import { responseLogWithNotification } from '../../../utils/utils';
import notificationDecorator from '../../Notifications/notificationDecorator';
import { createComand } from '../actions';
import TooltipWithPortal from '../../../components/base/Tooltip/TooltipWithPortal';

export default function HostGrid(props) {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const executeComand = (id, command) => {
    dispatch(createComand({ id, command })).then(() => {
      notificationDecorator({
        title: 'Создание команды',
        message: 'Создание команды успешно',
      });
    }).catch(responseLogWithNotification);
  };

  const availableCommandsFormatter = (_, item) => {
    const commandsList = item?.available_commands?.length ? item.available_commands : [];
    const commands = commandsList.filter(c => ['barrier_open_single', 'barrier_open', 'barrier_close'].includes(c));
    return (
      <div className="control-box-formatter">
        {commands.map((command, key) => (
          <div className="control-box-button" key={key}>
            <Icons width={28} height={28} customIcon icon={command} className="button-icons" />
            <div className="expanded-click-zone" onClick={e => { executeComand(item.id, command); e.stopPropagation(); e.preventDefault(); }} />
          </div>
        ))}
      </div>
    );
  };

  const defaultColumns = [
    {
      dataField: 'host',
      text: 'Объект',
      formatter: (_, a) => (<HostNameAndStatusFormatter item={a} isComponentBase />),
      disableSort: true,
      hidden: true,
      dataClassName: 'align-middle',
      headerClassName: 'host-column',
    },
    {
      dataField: 'active_components',
      text: 'Периферийные модули',
      formatter: EquipmentFormatter,
      disableSort: true,
      dataClassName: 'align-middle',
      headerClassName: 'active-components-column',
      hidden: true,
    },
    {
      dataField: 'vehicle_detection_state',
      text: 'Визуализация',
      formatter: (_, item) => (item?.type !== 'payment_terminal' ? visualFormatter(item?.vehicle_detection_state) : () => {}),
      disableSort: true,
      dataClassName: 'align-middle',
      hidden: true,
      headerClassName: 'detection-state-column',
    },
    {
      dataField: 'last_event',
      text: 'ГРЗ',
      formatter: vehicleRegistrationPlateFormatter,
      disableSort: true,
      dataClassName: 'align-middle',
      hidden: true,
      headerClassName: 'lpn-column',
    },
    {
      dataField: 'last_event',
      text: 'Последние данные',
      formatter: date => logFormatter(date && date.description ? date.description : '', date),
      disableSort: true,
      dataClassName: 'align-middle',
      hidden: true,
      headerClassName: 'last-event-column',
    },
    {
      dataField: 'available_commands',
      text: 'Доступные действия',
      formatter: availableCommandsFormatter,
      disableSort: true,
      dataClassName: 'align-middle',
      headerClassName: 'available-commands-column',
      hidden: true,
    },
  ];

  const {
    data,
    loadData,
    onClickByRow,
    meta,
    columns = defaultColumns,
  } = props;

  const moreFormatter = (_, item) => {
    const commandsList = item?.available_commands?.length ? item.available_commands : [];
    const commands = commandsList.filter(c => !['barrier_open_single', 'barrier_open', 'barrier_close'].includes(c));
    if (!commands.length) {
      return null;
    }
    return (
      <TooltipWithPortal
        content={<Icons customIcon icon="dot" className="more-vert" />}
        classNamePortal="more-actions"
        tooltipContent={(
          <div className="more-wrapper">
            {
              commands.map((command, key) => (
                <Button
                  key={key}
                  variant="link"
                  className="w-100 more-button"
                  onClick={() => executeComand(item.id, command)}
                >
                  {formatMessage({ id: `command.${command}`, defaultMessage: command })}
                </Button>
              ))
            }
          </div>
        )}
        classNameWrapper="more-tooltip-wrapper"
        className="more-tooltip"
      />
    );
  };

  return (
    <div className="host-table g-0">
      <div className="frame">
        <div className="sticky-table-wrapper custom-scroll-theme">
          <CustomizedGrid className="host-grid-main" data={data} columns={columns} name="session-list" onClickByRow={onClickByRow} settingsFormatter={moreFormatter} />
        </div>
      </div>
      <Pagination meta={meta} list={data} handleChangeMeta={loadData} />
    </div>
  );
}
